import { MdClear, MdDone } from 'react-icons/md';
import { ChangeEvent, FC, useState } from 'react';

import { useAppSelector } from '@shared/model';
import { selectTemplates } from '@entities/template';
import {
  containerStyle,
  iconStyle,
  iconsContainerStyle,
  inputContainerStyle,
  inputStyle,
  messageStyle,
  previewTextStyle,
} from './FilePreview.tailwind';

interface PropsType {
  filename: string;
  onSave: (id: number) => void;
  onCancel: () => void;
}

const FilePreview: FC<PropsType> = ({ filename, onSave, onCancel }) => {
  const templates = useAppSelector(selectTemplates);
  const [templateId, setTemplateId] = useState('');
  const [isError, setIsError] = useState(false);

  const ids = templates.map(t => t.templateNumber);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    setIsError(ids.includes(+value));
    setTemplateId(value);
  };

  const handleSave = () => {
    if (!ids.includes(+templateId) && templateId) {
      onSave(+templateId);
    }
  };

  return (
    <div className={containerStyle}>
      <div className={inputContainerStyle}>
        <input
          className={inputStyle}
          placeholder="Id"
          type="number"
          value={templateId}
          onChange={handleChange}
          data-id="input-TemplateId"
        />
      </div>

      <span className={previewTextStyle}>{beutifyFilename(filename)}</span>

      <div className={iconsContainerStyle}>
        <MdDone className={iconStyle} onClick={handleSave} data-id="svg-Save" />
        <MdClear className={iconStyle} onClick={onCancel} data-id="svg-Cancel" />
      </div>

      {isError ? (
        <div className={messageStyle} data-id="div-ErrorMessage">
          Id is already taken
        </div>
      ) : null}
    </div>
  );
};

const beutifyFilename = (filename: string) => {
  return filename.length > 30 ? filename.slice(0, 30) + '...' : filename;
};

export default FilePreview;
